import { avaleht } from './pages/avaleht';
import { oksjonid } from './pages/oksjonid';
import { tekstid } from './pages/tekstid';
import { hinnakalkulaator } from './pages/hinnakalkulaator';
import { kaardirakendus } from './pages/kaardirakendus';
import { metsamaterjal } from './pages/metsamaterjal';
import { registreeru } from './pages/registreeru';
import { minuTarnekohad } from './pages/minu_tarnekohad';
import { kaart } from './pages/kaart';
import { multioksjon } from './pages/multioksjon';
import { lisanOksjoni } from './pages/lisan_oksjoni';
import { soovinMyya } from './pages/soovin_myya';
import { tooltip } from './modules/tooltip';
import { tabs } from './modules/tabs';
import { SessionManager } from './modules/sessionManager';
import { handleLisaTeenusBtnClick, handeOrderBtnClick } from './modules/handler';
import { Metsaoksjon } from './modules/metsaoksjon';
import { equalizer } from './modules/equalizer';
import { toFixedNumber } from './modules/utilities';
import { maaAmet } from './modules/uri.js';
import { showLoginModal } from './modules/modal.js';

import $ from 'jquery';
window.jQuery = $;
window.$ = $;
console.warn('jQuery is included', $)

window['MO'] = new Metsaoksjon();
window.equalizer = equalizer;
window.toFixedNumber = toFixedNumber;
window.Metsaoksjon = Metsaoksjon;
window.maaAmet = maaAmet;
window.showLoginModal = showLoginModal;

var map, myLatlng, marker, directionsService, loginMethod, activeCalculatorTab = "";

window.map = map;
window.myLatlng = myLatlng;
window.marker = marker;
window.directionsService = directionsService;
window.loginMethod = loginMethod;
window.activeCalculatorTab = activeCalculatorTab;

// ? inline functions made global
window.handleLisaTeenusBtnClick = handleLisaTeenusBtnClick;
window.handeOrderBtnClick = handeOrderBtnClick;

require('../node_modules/foundation-sites/dist/js/foundation.min.js');

require('./vendor/slick/myslick.js');
require('./vendor/slick/slick.min.js');

require('./vendor/noty/jquery.noty.js');
require('./vendor/noty/promise.js');
require('./vendor/noty/layouts/bottom.js');
require('./vendor/noty/layouts/bottomCenter.js');
require('./vendor/noty/layouts/bottomLeft.js');
require('./vendor/noty/layouts/bottomRight.js');
require('./vendor/noty/layouts/center.js');
require('./vendor/noty/layouts/centerLeft.js');
require('./vendor/noty/layouts/centerRight.js');
require('./vendor/noty/layouts/inline.js');
require('./vendor/noty/layouts/top.js');
require('./vendor/noty/layouts/topCenter.js');
require('./vendor/noty/layouts/topLeft.js');
require('./vendor/noty/layouts/topRight.js');
require('./vendor/noty/themes/default.js');
require('./vendor/datepicker.js');
require('./vendor/custom-lightbox.js');
require('./vendor/summernote.min.js');
require('./vendor/svg4everybody.js');
require('./vendor/timepicker.js');

require('./modules/global'); // * ✓
require('./modules/utilities'); // * ✓
require('./modules/uri'); // * ✓
require('./modules/sessionManager'); // * ✓
require('./modules/modal'); // * ✓
require('./modules/metsaoksjon'); // TODO ✓
require('./modules/setMarker'); // * ✓
require('./modules/cookies'); // * ✓
require('./modules/tooltip'); // * ✓
require('./modules/tabs'); // * ✓

require('./pages/avaleht'); // TODO ✓
require('./pages/oksjonid'); // TODO ✓
require('./pages/tekstid'); // TODO ✓
require('./pages/hinnakalkulaator'); // TODO ✓
require('./pages/kaardirakendus'); // TODO ✓
require('./pages/metsamaterjal'); // TODO ✓
require('./pages/registreeru'); // TODO ✓
require('./pages/minu_tarnekohad'); // TODO ✓
require('./pages/kaart'); // TODO ✓
require('./pages/multioksjon'); // TODO ✓
require('./pages/lisan_oksjoni'); // TODO ✓
require('./pages/soovin_myya'); // TODO ✓

"use strict";

require('./modules/equalizer'); // * ✓
require('./modules/responsive'); // * ✓
require('./modules/events'); // * ✓
require('./modules/handler'); // * ✓
require('./modules/clone'); // TODO ✓
require('./modules/slick'); // * ✓

// ? connected files
require('../pages/metsakindlustus.js');
require('../kaart/js/vendor/spectrum.js');

$(function() {

    $(document).foundation();

    let MOSO;

	MOSO = new SessionManager();
	if (!(USER_ID > 0)) {
		MOSO.disable();
	}

	setInterval(function() {
		$.get("/ping");
	}, 60000);

    avaleht();
    oksjonid();
    tekstid();
    hinnakalkulaator();
    kaardirakendus();
    metsamaterjal();
    registreeru();
    minuTarnekohad();
    kaart();
    multioksjon();
    lisanOksjoni();
    soovinMyya();

    tooltip();
    tabs();

});